/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

var _excluded = ["alt", "className", "src"];
var CardImage = function CardImage(_ref) {
  var alt = _ref.alt,
    className = _ref.className,
    src = _ref.src,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("div", _extends({}, rest, {
      className: classnames('cpc--card__image-wrap', className)
    }), /*#__PURE__*/React.createElement("img", {
      className: "cpc--card__image",
      src: src,
      alt: alt
    }))
  );
};
CardImage.propTypes = {
  /**
   * A description of the image being rendered.
   */
  alt: PropTypes.string.isRequired,
  /**
   * A className to be provided to the CardImage component.
   */
  className: PropTypes.string,
  /**
   * The url of the image that should be rendered.
   */
  src: PropTypes.string.isRequired,
  /**
   * Any styles to apply to the CardImage component. To control the aspect ratio of the image set the paddingTop
   * property to the width of the image divided by the height as a percentage (e.g. 16:9 aspect ratio would be
   * 56.25%).
   */
  style: PropTypes.shape({})
};
var CardImage$1 = CardImage;

export { CardImage$1 as default };
